module.exports = __webpack_public_path__ + "static/media/video-bg-2.0c774307.jpg";